import { t } from "../../../services/utils";
import React from "react";
import achievementTypes from "../../../constants/achievement-types";
import AchievementView from "./AchievementView";
class AchievementDetailView extends React.Component {
  constructor(props) {
    super(props);
  }
  getAchievementDetails = (exercise, index) => {
    let achievement;
    if (exercise.is_pr_rm) {
      achievement = {
        type: achievementTypes.PR,
        pr_type: "rm",
        en: exercise.en,
        rm: exercise.rm,
      };
      return <AchievementView key={index} achievement={achievement} />;
    }
    if (exercise.is_pr_vol) {
      achievement = {
        type: achievementTypes.PR,
        pr_type: "vol",
        en: exercise.en,
        vol: exercise.vol,
      };
      // key: `ac-vol-${exercise.eid}-${this.story.story_id}`
      return <AchievementView key={index} achievement={achievement} />;
    }
  };

  // key: `ac-rm-${exercise.eid}-${this.story.story_id}`
  render = () => {
    let styles = {
      container: {
        backgroundColor: "white",
        height: "100%",
        alignItems: "center",
        borderLeft: "1px solid #EAE9EF",
        borderRight: "1px solid #EAE9EF",
        paddingTop: 20,
      },
      heading: {
        fontSize: 14,
        color: "#2A234E",
        marginRight: 20,
        fontWeight: "bold",
        textTransform: "uppercase",
      },
      achievementsContainer: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        marginTop: 20,
        gap: 10,
      },
      content: {
        padding: "25px 16px 25px 16px",
        borderTop: "1px solid #EAE9EF",
        borderBottom: "1px solid #EAE9EF",
      },
    };
    const { workout, achievements } = this.props;
    return (
      <div style={styles.container} data-testid="story-achievement">
        <div style={styles.content}>
          <div style={styles.heading}>{t("achievements")}</div>
          <div style={styles.achievementsContainer}>
            {workout.map((exercise, index) => {
              return this.getAchievementDetails(exercise, index);
            })}
            {achievements &&
              achievements.length > 0 &&
              achievements.map((achievement, index) => {
                return (
                  <AchievementView key={index} achievement={achievement} />
                );
              })}
          </div>
        </div>
      </div>
    );
  };
  static getHeight(props) {
    const { workout, achievements } = props;
    let height = 0;
    let achievementCount = 0;
    for (let i = 0; i < workout.length; i++) {
      let exercise = workout[i];
      if (exercise.is_pr_rm || exercise.is_pr_vol) {
        achievementCount += 1;
      }
    }
    if (achievements) {
      achievementCount += achievements.length;
    }
    const achievementsHeight =
      Math.ceil(achievementCount / 2) * 75 +
      Math.ceil(achievementCount / 2) * 10;
    return achievementsHeight + 20 + 20 + 16 + 18; // adding paddingtop/bottom, margintop and border bottom pixels
  }
}

export default AchievementDetailView;
